/**
 * @desc 更新
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseOrganizeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseOrganize/updateData`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
